var POPUP_CLASS_BY_NAME = {
  "POWER UNLEASHED": "n2x",
  "Stealth Mode": "n2x",
  "noise": "n2x",
  "comfortable": "n2x_large",
  "comfortable_camo": "n2x_large"
};

var POPUP_CONTENT_BY_PAIR = {
  "discover_m|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Auto. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "discover_3|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Tour, Trail, Sport, Boost. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "summit_2|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Pulse. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "tempo|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Pulse. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "Gomad|5 Modes": "<div class='pop-text-content'><div class='pb-20'>Simply select one riding mode: Eco, Trail, Sport, Boost, Stealth. Each mode directly corresponds to specific riding scenarios, providing simpler operation and more consistent experience.</div><div class='pb-10'></div></div>",
  "breeze_1|Low": `<div class='pop-text-content'>
    <div class='pb-20'>
      <h6>What does 'Low Motor Noise' mean?</h6>
      <div class="pb-10">Delivering mighty 750W power with industry-leading quietness, Breeze 1 operates at just 58dB - 9x quieter than average Ebike players (68dB).</div>
      <h6>Why does it matter?</h6>
      <div>A super quiet motor like Breeze 1’ means two awesome things for you:</div><div>1. Enjoy your ride in peace – No ear-piercing buzz or rumble. Hear only the sound of nature & your breath – yeah, that’s how calm it is.</div><div>2. Stay discreet – When you ride with friends, they’ll think you’re on a regular bike… because there’s barely any noise to give it away!</div>
    </div></div>`,
  "brandEdge|ul": "<div class='pop-text-content'><div class='pb-20'>UL Solutions is a global leader in safety, helping products meet the highest standards worldwide. UL Certification marks are a recognized symbol of trust, proving batteries and electrical systems are tested and safe.</div></div>",
  "fold_1_plus|torqueSensor": "<div class='pop-text-content'><div class='pb-20'>Torque Mode gives you smooth, responsive control — great for trails or climbs.</div></div>",
  "fold_1_plus|cadenceSensor": "<div class='pop-text-content'><div class='pb-20'>Cadence Mode provides constant support with light pedaling for cruising.</div></div>",
  "gomad|free_gift": `<div class="pop-text-content"><h3 class="h6 text-center">Velotric Gift Box (worth $139)</h3><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/gomad-freegift.webp?v=1775543708" style="width:100%;" />
      <div class="donate-content grid-content">
          <div>① Reusable Water Bottle</div>
          <div>② Velotric Cap</div>
          <div>③ Wool Socks</div>
          <div>④ Sticker Pack</div>
          <div>⑤ Ride Log Calendar</div>
          <div>⑥ Velotric Keychain</div>
    </div></div>`,
  "tempo|free_gift": `<div class="pop-text-content"><h3 class="h6 text-center">Velotric Gift Box (worth $139)</h3><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/velotric_tempo_gift_box.webp?v=1772274492" style="width:100%;" />
      <div class="donate-content grid-content">
          <div>① Reusable Water Bottle</div>
          <div>② Velotric Cap</div>
          <div>③ Wool Socks</div>
          <div>④ Sticker Pack</div>
          <div>⑤ Ride Log Calendar</div>
          <div>⑥ Velotric Keychain</div>
    </div></div>`,
  "folding_pillar|ComfortMax": `<div class='pop-text-content'>
    <div class='pb-20'>
      <div>ComfortMax™ combines a rear-tilted seat tube that absorbs bumps, an optimized golden-ratio frame for
                <strong>upright posture</strong>, and a <strong>400mm ultra-low step-through</strong> for effortless mounting. With <strong>60mm travel suspension
                and wide tires</strong> to soak up vibrations, every trip feels balanced and fatigue-free—even on longer rides. </div><div><small>*Selected features are exclusively available on the Fold 1 Plus model.</small></div>
    </div></div>`,
  "folding_pillar|Adaptive Power": `<div class='pop-text-content'>
    <div class='pb-20'>
      <div>With a 750W motor (1100W peak), 75Nm torque, and <strong>SensorSwap™</strong> technology, adjust power delivery in real
                time, with instant <strong>torque on hills</strong> and smooth <strong>cadence on flats</strong>. A 48V 13Ah <strong>IPX7 battery</strong> and <strong>IPX6-rated
                frame</strong> keep you rolling up to <strong>68 miles</strong>, rain or shine, with stormproof reliability every ride. </div><div><small>*Selected features are exclusively available on the Fold 1 Plus model.</small></div>
    </div></div>`,
  "folding_pillar|Smarter Folding": `<div class='pop-text-content'>
    <div class='pb-20'>
      <div>A <strong>3-step folding</strong> system and 3-minute tool-free assembly shrink the bike to a compact 37.8" x 19.7" x
                33.5" footprint—<strong>30% smaller than standard Ebikes</strong>. At just 62 lbs yet rated for a <strong>450-lb payload</strong>, it
                delivers true grab-and-go versatility without sacrificing strength, whether you’re storing, traveling,
                or commuting daily. </div><div><small>*Selected features are exclusively available on the Fold 1 Plus model.</small></div>
    </div></div>`
};

var POPUP_CONTENT_BY_NAME = {
  "Customizable": "<div class='pop-text-content'><div class='pb-20'>Choose from 15 acceleration curves across Eco, Trail, and Boost modes, each with 5 pedal assist levels on the control panel or in the Velotric app. Adjust speed and power to match your ride—whether for efficiency, balance, or max performance.</div><div class='pb-10'></div></div>",
  "Battery IPX7": "<div class='pop-text-content'><div class='pb-20'>IPX7 Waterproof Battery, IPX6 Waterproof Bike for all-weather riding</div></div>",
  "all": '<div class="pop-text-content"><h3 class="pb-15 text-center">VELOTRIC</h3><div class="pb-15">Notice: Due to the implementation of new Tariffs, pricing on select models may increase starting <strong>April 15th, 2025</strong>. This decision is necessary to ensure that we can continue to provide the high-quality Ebikes you love, while meeting the new tariffs. You can still enjoy current prices if you purchase before April 15th. Don’t miss your chance—lock in the best deal today!</div><div class="pb-15"></div></div>',
  "POWER UNLEASHED": `<div class="pop-text-content"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/Group_48101931_1.svg?v=1747220566"/><div class="donate-content">
  </div></div>`,
    "Stealth Mode": "<div class='pop-text-content'><div>Stealth Mode is co-developed with <a href='https://www.velotricbike.com/blogs/story-landing/joltbike-design-house-outdoors-ebike-brand' target='_blank'>JoltBike Design House</a>.</div></div>",
    "comfortable": `<div class="pop-text-content"><img class="mb-down--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/image_2461d594-4477-409e-ae58-f690e6aba084.webp?v=1747217457"/><img class="mb-up--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101932.webp?v=1747217877"/><div class="donate-content">
  </div></div>`,
    "comfortable_camo": `<div class="pop-text-content"><img class="mb-down--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/comfortmax-camo-pc.webp?v=1750910447"/><img class="mb-up--hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/comfortmax-camo-mb.webp?v=1750910447"/><div class="donate-content">
  </div></div>`,
    "noise": `<div class="pop-text-content"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/quiet-movement-2.webp?v=1750925892"/><div class="donate-content">
  </div></div>`
};

var POPUP_CONTENT_BY_CONTENT = {
  "key": '<img class="pop-mb-hide" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/20240228-183235.jpg?v=1709116378" width="910" height="auto" /><img class="pop-mb-show" src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/20240228-183235.jpg?v=1709116378" width="393" height="auto" /><div class="pop-text-content"><div><p>You can locate the number in the area indicated in the picture above. The number begins with VL CT or KL, and you only need to type in the numerical digits.</p></div></div>',
  "doublepoints": '<div class="pop-text-content" style="background-color: #A4E4FF;margin:0;max-width: 100%;"><img src="https://cdn.shopify.com/s/files/1/0599/2094/1239/files/frame_48101405.webp?v=1718958091" /></div>',
  "fold_1": '<div class="pop-text-content back-in-stock"><h3>Velotric Fold 1 E-Bike</h3><div class="pb-15">Sign up to receive a notification when this item is back in stock and available to ship.</div><div class="pb-15"><input type="email" placeholder="Email" class="back_in_stock form-control" /></div><button type="submit" class="btn btn-success btn-lg col-xs-12" onclick="notifysubmit()">Notify Me When It Is In Stock</button><div id="completed_message" class="completed_message alert alert-success" style="display: none;">You are in! We will let you know when this item is back in stock and available to ship.</div></div>'
};
// function openPagePop(content, name) {
//   const popupRoot = document.querySelector("#custom_popup");
//   if (!popupRoot) return;

//   const popup = popupRoot.querySelector(".popup");
//   const popupContent = popupRoot.querySelector(".popup__content");

//   if (popup) {
//     popup.classList.remove("n2x", "n2x_large");
//     if (POPUP_CLASS_BY_NAME[name]) {
//       popup.classList.add(POPUP_CLASS_BY_NAME[name]);
//     }
//   }

//   const matchedHtml =
//     POPUP_CONTENT_BY_PAIR[`${content}|${name}`] ||
//     POPUP_CONTENT_BY_NAME[name] ||
//     POPUP_CONTENT_BY_CONTENT[content];

//   if (popupContent && matchedHtml) {
//     popupContent.innerHTML = matchedHtml;
//   } else {
//     console.warn("[openPagePop] popup content not found:", content, name);
//   }

//   if (content === "compare") {
//     let selectedProducts = [];
//     const compareListRaw = localStorage.getItem("compare_list");

//     if (compareListRaw && compareListRaw !== "undefined") {
//       try {
//         selectedProducts = JSON.parse(compareListRaw) || [];
//       } catch {
//         selectedProducts = [];
//       }
//     }

//     if (!selectedProducts.includes(name)) {
//       selectedProducts.push(name);
//       localStorage.setItem("compare_list", JSON.stringify(selectedProducts));
//     }

//     const comparePopup = document.querySelector("#compare_popup");
//     if (comparePopup) comparePopup.classList.add("active");
//     return;
//   }

//   popupRoot.classList.add("active");
// }

// $(".custom-popup-group .popup.popup-promo").on('click', function(e) {
//   if ($(e.target).closest('.popup__content').length > 0) {
//   } else {
//     $(".custom-popup-group").removeClass("active");
//   }
// });
// $(".custom-popup-group .popup__close-button").on('click', function(e) {
//   $(".custom-popup-group").removeClass("active"); 
// });
function openPagePop(content, name) {
  if (window.VelotricApp && window.VelotricApp.popup) {
    window.VelotricApp.popup.open({ content: content, name: name });
    return;
  }

  console.warn("[openPagePop] App.popup is not ready yet", content, name);
}


/*** product bundle ***/

$('.js_bundle').click(function(e) {
    var $target = $(e.target);
  var $wrap = $(this).closest('.bundle-wrap');
  var bundle_item = $wrap.attr('data-bundle');
  var $checkbox = $wrap.find('.bundle-checkbox');
  var ischeck = false;

  /* -----------------------
   * 1. View All：只展开
   * ----------------------- */
  if ($target.closest('.view-all').length) {
    e.stopPropagation();
    $wrap.toggleClass('is-open');
    return;
  }

  /* -----------------------
   * 2. checkbox 本身
   * ----------------------- */
  if ($target.is('.bundle-checkbox')) {
    ischeck = $checkbox.prop('checked');
    $wrap.toggleClass('active', ischeck);
  } 
  /* -----------------------
   * 3. 点击卡片其他区域
   * ----------------------- */
  else {
    ischeck = !$checkbox.prop('checked');
    $checkbox.prop('checked', ischeck);
    $wrap.toggleClass('active', ischeck);
  }
   console.log(ischeck);
   var rebuyItems = $('.rebuy-container .acc-addon__item');
    var bike = $(".product-general-info-block h1.h5").text() || $("#header-component h1.edit_positon_title").text();
    if(bike.indexOf("Discover 2") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Phone Mount","Velotric Water Bottle & Cage","Velotric Left Mirror","Double Spring Comfort Saddle"]
    }else if(bike.indexOf("Discover 3") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Phone Mount","Velotric Water Bottle & Cage","Velotric Left Mirror","Velotric Rack Top Bag"]
    }else if(bike.indexOf("Discover M") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Phone Mount","Velotric Water Bottle & Cage","Velotric Left Mirror","Velotric Rack Top Bag"]
    }else if(bike.indexOf("Summit 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Summit 1 Rear Rack","Velotric Phone Mount","Velotric Summit 1 Fender","Velotric Left Mirror"]
    }else if(bike.indexOf("Summit 2") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Summit 2 Modular Rear Rack","Velotric Phone Mount","Velotric Water Bottle & Cage","Velotric Left Mirror"]
    }else if(bike.indexOf("Breeze 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Water Bottle & Cage","Velotric Left Mirror","Velotric ComfortMax Saddle","Velotric Phone Mount"]
    }else if(bike.indexOf("Fold 1 Ebike") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Water Bottle & Cage","Velotric Wheel Guard","Velotric Rack Top Bag"]
    }else if(bike.indexOf("Fold 1 Plus") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Left Mirror","Velotric Water Bottle & Cage","Velotric Phone Mount"]
    }else if(bike.indexOf("T1 ST") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric T1 ST Modular Rear Rack","Velotric Phone Mount","Velotric T1 Series Fender Pack","Velotric Left Mirror"]
    }else if(bike.indexOf("Nomad 1") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Water Bottle & Cage","Double Spring Comfort Saddle","Velotric Front Basket","Velotric Left Mirror"]
    }else if(bike.indexOf("Nomad 2") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Rear Basket (M) 2.0","Velotric Left Mirror","Double Spring Comfort Saddle", "Velotric Front Basket"]
    }else if(bike.indexOf("Triker") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Front Basket","Velotric Water Bottle & Cage","Velotric Folding Lock"]
    }else if(bike.indexOf("Velotric Tempo Ebike") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Left Mirror","Velotric Tempo Fender","Velotric Phone Mount","Velotric Tempo Rear Rack"]
    }else if(bike.indexOf("Velotric GoMad Ebike") > -1 && bundle_item == "a"){
      var product_title_arr = ["Velotric Left Mirror","Velotric Front Rack","Velotric Phone Mount","Velotric Water Bottle & Cage"]
    }
    console.log(product_title_arr);
    console.log(rebuyItems);
   if(product_title_arr){
     rebuyItems.each(function () {
      // var title = $(this).find('.acc-addon__item-info .rebuy-product-title').text();
      var title = $(this).find('.acc-addon__item-info .rebuy-product-title').attr('alt');
      console.log(title);
      var checkbox = $(this).find('.checkbox-input.acc-checkbox');
      if(product_title_arr.indexOf(title) > -1){
        // console.log(checkbox.prop('checked'))
        if(!checkbox.prop('checked') && title == "Velotric Packer 1 Seat Pad"){
          checkbox.prop('checked', true);
        }
        if(!checkbox.prop('checked') && $wrap.hasClass("active")){
          checkbox.trigger('click');
        }else if(checkbox.prop('checked') && !$wrap.hasClass("active")){
          checkbox.trigger('click');
        }
        
      }else{
        if(checkbox.prop('checked')){
          checkbox.trigger('click');
        }
      }
    })
   }    
  })
// $('.bundle_img').click(function() {
//     var imageUrl = $(this).find("img").attr('src');
//     $('.zoomed-image').attr('src', imageUrl);
//     $('.bundle-image-overlay').addClass('active');
//   });

  $('.bundle-image-overlay').click(function() {
    $(this).removeClass('active');
  });
  $(document).on('click', '#rebuy-expandButton', function () {
    var $btn = $(this);
    var $el  = $('.rebuy-wrap .acc-addon__items');

    var isCollapsed = $el.hasClass('rebuy-collapse');

    if (isCollapsed) {
      // ===== Show Less =====
      var prevScrollTop = $btn.data('scroll-top');

      // 1. 冻结滚动
      $('body').addClass('rebuy-lock-scroll');

      // 2. 折叠 DOM
      $el.removeClass('rebuy-collapse');

      // 3. 同步还原 scroll（同一帧）
      if (typeof prevScrollTop === 'number') {
        window.scrollTo(0, prevScrollTop);
      }

      // 4. 下一帧解锁
      requestAnimationFrame(function () {
        $('body').removeClass('rebuy-lock-scroll');
      });

    } else {
      // ===== Show More =====
      $btn.data('scroll-top', $(window).scrollTop());
      $el.addClass('rebuy-collapse');
    }

    $btn.text($el.hasClass('rebuy-collapse') ? 'Show Less' : 'Show More');

    var _window_dataLayer;   
    const breadcrumb = $(".breadcrumbs .breadcrumb__link").text().trim();
    const buttonName = $(this).text().trim();
    const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName,action:open  };
    null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_acc_btn", event_parameters: parameters });
  });

  $(document).on('click','.rebuy-footer a', function() {
    var _window_dataLayer;   
    const breadcrumb = $(".breadcrumbs .breadcrumb__link").text().trim();
    const buttonName = $(this).text().trim();
    const parameters = { page_name: "Product Page_" + breadcrumb,button_name: buttonName  };
    null === (_window_dataLayer = window.dataLayer) || void 0 === _window_dataLayer ? void 0 : _window_dataLayer.push({ event: "ga4Event", event_name: "click_acc_btn", event_parameters: parameters });
  });

  function updateStickyAtcPrice() {
    const priceEl = document.querySelector(
      '.sticky-atc__inner [data-sticky-price]'
    );
    if (!priceEl) return;

    const basePrice = Number(priceEl.dataset.price || 0); // 分
    const accPrice  = Number(priceEl.dataset.accPrice || 0); // 分

    const finalPrice = basePrice + accPrice;
    console.log(basePrice);
    console.log(accPrice);
    console.log(finalPrice);
    const displayPrice = (finalPrice / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    priceEl.innerHTML = '$' + displayPrice;
  }


  function isThreeOrMoreChecked(checkboxes) {
    let checkedCount = 0;
    let totalValue = 0;
    let totalPrice = 0;
    for (const checkbox of checkboxes) {
        if (checkbox.checked) {
            checkedCount++;
            var savedP = parseFloat(checkbox.closest(".acc-addon__item").dataset.saved);
            var originP = parseFloat(checkbox.closest(".acc-addon__item").dataset.price)
            totalValue += savedP;
            totalPrice += originP;
        }
    }
    totalValue = totalValue.toFixed(2);
    totalPrice = totalPrice.toFixed(2);
    return [checkedCount,totalValue, totalPrice];
  }
  

$(document).on('change', '.custom-pdp-bundles-pc .rebuy-container #offer input[type="checkbox"], .custom-pdp-bundles-mb .rebuy-container #offer input[type="checkbox"]', function () {
  const $checkbox = $(this);
  const $container = $checkbox.closest('.custom-pdp-bundles-pc, .custom-pdp-bundles-mb').find('.rebuy-container');

  const $savedText         = $container.find('.saved_text');
  const $selectedNum       = $container.find('.selected-num');
  const $salePrice         = $container.find('.sale_price');
  const $offerPrice        = $container.find('.offer_price');
  const $offerOriginPrice  = $container.find('.offer-origin_price');
  const $checkboxes        = $container.find('#offer input[type="checkbox"]');
  const $offerBundle       = $checkbox.closest(".offer-bundle");

  const num = $checkbox.closest(".acc-addon__item").data("num") * 1;
  if (num <= 0) return;

  const sales = $container.find('.saved_text').data("sale");
  const data  = isThreeOrMoreChecked($checkboxes); // data[0]: 已选数量, data[1]: 节省金额
  var totalPrice = data[2];

  $offerBundle.toggleClass('active', $checkbox.prop('checked'));
  $selectedNum.text(data[0]);
  if (data[0] < num) {
    $savedText.text(`Add ${num - data[0]}, save ${sales}%`);
    $salePrice.addClass("hidden");
    $offerPrice.removeClass("del");
    $offerOriginPrice.removeClass("hidden");
  } else {
    $savedText.text(`Order Now & Save $${data[1]}`);
    $salePrice.removeClass("hidden");
    $offerPrice.addClass("del");
    $offerOriginPrice.addClass("hidden");
    totalPrice = totalPrice * 0.7;
  }

  const addAccEl = document.querySelector(
    '.sticky-atc__inner .add-ons-num'
  );
  if(data[0] > 0){
    addAccEl.innerHTML = " + Add-ons × " + data[0];
  }else{
    addAccEl.innerHTML = "";
  }
  const stickyPriceEl = document.querySelector(
    '.sticky-atc__inner [data-sticky-price]'
  );

  if (stickyPriceEl) {
    // 美元 → 分
    const accPriceCents = totalPrice * 100;
    stickyPriceEl.dataset.accPrice = accPriceCents;

    updateStickyAtcPrice();
  }
});
$('.offer-bundle').on('click', function (e) {
  var $target = $(e.target);
  var $card = $(this);
  var $checkbox = $card.find('.acc-checkbox');
  
  /* -----------------------
   * 1. 排除不应触发选中的区域
   * ----------------------- */
  if (
    $target.is('select') ||
    $target.closest('select').length ||
    $target.closest('.acc-addon__item-learn-more').length
  ) {
    return;
  }

  /* -----------------------
   * 2. 点击 checkbox 本身
   * ----------------------- */
  if ($target.is('.acc-checkbox')) {
    $card.toggleClass('active', $checkbox.prop('checked'));
    return;
  }

  /* -----------------------
   * 3. 点击卡片其他区域
   * ----------------------- */
  $checkbox.trigger('click');
});

// acc-select change
$('.rebuy-container #offer .acc-addon__items .acc-select, .rebuy-container #free .acc-addon__items .acc-select').on('change', function() {
  // var selectedPrice = $('option:selected', this).data('price');
  var selectedImage = $('option:selected', this).data('image');
  // $(".rebuy-money-val").text(selectedPrice);
  if(selectedImage){
    var image= $(this).closest('.acc-addon__item').find('.acc-addon__item-image img');
    image.attr("src",selectedImage)
  }
})
// product bundle quick view
$(document).on('click','.quick-view__content .add-acc-btn', function() {
  const form = $(this).closest(".product__info").find(".product-form-wrap form");
  var productId = form.find('input[name="product-id"]').val()*1;
  var vId = form.find('input[name="id"]').val();
  $('.rebuy-wrap .tab-content.active .acc-addon__items product-card').each(function() {
    var productCardId = $(this).data('id');
    if (productCardId === productId) {
      $(this).find('input[type="checkbox"]').prop('checked', true);
      var selectElement = $(this).find('select');
      if (selectElement.length) {
        selectElement.val(vId);
        selectElement.trigger('change');
      }
    }
  });
 $(".body-overlay").trigger('click');
})
  function openTab(evt, tabName,wrapClass) {
    var i, tabcontent, tabbuttons;
    var wrap = document.querySelector("."+wrapClass);
    tabcontent = wrap.querySelectorAll(".tab-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove("active");
    }
    tabbuttons = wrap.querySelectorAll(".tab-button");
    for (i = 0; i < tabbuttons.length; i++) {
      tabbuttons[i].className = tabbuttons[i].className.replace(" active", "");
    }
    wrap.querySelector("#" + tabName).classList.add("active");
    
    evt.currentTarget.className += " active";
  }
/*** end product bundle ***/

function initProduct360Viewer($pane) {
  if (!$pane.length || $pane.data('viewerInited')) return;

  var viewer = $pane.find('[data-product-360-viewer]')[0];
  if (!viewer) return;

  var frames = $pane.find('.product-media-360-frame');
  if (!frames.length) return;

  var state = {
    frameCount: frames.length,
    frameIndex: 0,
    startX: 0,
    dragging: false,
    pointerId: null,
    threshold: 12,
    loadPromiseMap: {},
    preloadStarted: false
  };

  function normalizeIndex(index) {
    return ((index % state.frameCount) + state.frameCount) % state.frameCount;
  }

  function markFrameLoaded(index) {
    frames.eq(index).attr('data-loaded', 'true');
  }

  function isFrameLoaded(index) {
    return frames.eq(index).attr('data-loaded') === 'true';
  }

  function activateFrame(index) {
    state.frameIndex = index;
    frames.removeClass('is-active').eq(index).addClass('is-active');
  }

  function loadFrame(index) {
    var normalized = normalizeIndex(index);
    var $frame = frames.eq(normalized);

    if (isFrameLoaded(normalized)) {
      return Promise.resolve(normalized);
    }

    if (state.loadPromiseMap[normalized]) {
      return state.loadPromiseMap[normalized];
    }

    var frameSrc = $frame.attr('data-frame-src');
    if (!frameSrc) {
      markFrameLoaded(normalized);
      return Promise.resolve(normalized);
    }

    state.loadPromiseMap[normalized] = new Promise(function(resolve) {
      var preloader = new Image();
      preloader.onload = function() {
        $frame.attr('src', frameSrc);
        markFrameLoaded(normalized);
        resolve(normalized);
      };
      preloader.onerror = function() {
        resolve(normalized);
      };
      preloader.src = frameSrc;
    }).finally(function() {
      delete state.loadPromiseMap[normalized];
    });

    return state.loadPromiseMap[normalized];
  }

  function runQueue(indices, concurrency) {
    if (!indices.length) return Promise.resolve();

    return new Promise(function(resolve) {
      var cursor = 0;
      var activeCount = 0;

      function pump() {
        while (activeCount < concurrency && cursor < indices.length) {
          var frameIndex = indices[cursor];
          cursor += 1;
          activeCount += 1;

          loadFrame(frameIndex).finally(function() {
            activeCount -= 1;
            if (cursor >= indices.length && activeCount === 0) {
              resolve();
              return;
            }
            pump();
          });
        }
      }

      pump();
    });
  }

  function circularDistance(fromIndex, toIndex) {
    var direct = Math.abs(fromIndex - toIndex);
    return Math.min(direct, state.frameCount - direct);
  }

  function findLoadedFallback(targetIndex, direction) {
    for (var step = 1; step < state.frameCount; step += 1) {
      var candidate = normalizeIndex(targetIndex - direction * step);
      if (isFrameLoaded(candidate)) {
        return candidate;
      }
    }
    return state.frameIndex;
  }

  function startPreload() {
    if (state.preloadStarted || state.frameCount < 2) return;
    state.preloadStarted = true;

    var preloadIndexMap = {};
    for (var i = 0; i < state.frameCount; i += 1) {
      // Even frames are already requested via src in Liquid.
      // Here we prioritize odd frames to complete the sequence quickly.
      if (i % 2 === 0) continue;
      var index = normalizeIndex(i);
      if (index === state.frameIndex) continue;
      preloadIndexMap[index] = true;
    }

    var uniqueTargets = Object.keys(preloadIndexMap).map(function(key) {
      return parseInt(key, 10);
    });
    uniqueTargets.sort(function(a, b) {
      return circularDistance(state.frameIndex, a) - circularDistance(state.frameIndex, b);
    });

    runQueue(uniqueTargets, 4);
  }

  function setFrame(index, direction) {
    var normalized = normalizeIndex(index);
    if (isFrameLoaded(normalized)) {
      activateFrame(normalized);
      return;
    }
    var fallbackIndex = findLoadedFallback(normalized, direction || 1);
    if (fallbackIndex !== state.frameIndex) {
      activateFrame(fallbackIndex);
    }
    loadFrame(normalized).then(function(loadedIndex) {
      activateFrame(loadedIndex);
    });
  }

  function handlePointerMove(event) {
    if (!state.dragging || (state.pointerId !== null && event.pointerId !== state.pointerId)) return;
    if (event.cancelable) event.preventDefault();
    var deltaX = event.clientX - state.startX;
    if (Math.abs(deltaX) < state.threshold) return;

    var steps = Math.floor(Math.abs(deltaX) / state.threshold);
    var direction = deltaX > 0 ? -1 : 1;
    setFrame(state.frameIndex + direction * steps, direction);
    state.startX = event.clientX;
  }

  function handlePointerUp(event) {
    if (state.pointerId !== null && event.pointerId !== state.pointerId) return;
    state.dragging = false;
    viewer.classList.remove('is-dragging');
    if (state.pointerId !== null && viewer.hasPointerCapture && viewer.hasPointerCapture(state.pointerId)) {
      viewer.releasePointerCapture(state.pointerId);
    }
    state.pointerId = null;
  }

  viewer.addEventListener('pointerdown', function(event) {
    startPreload();
    state.dragging = true;
    state.startX = event.clientX;
    state.pointerId = event.pointerId;
    viewer.classList.add('is-dragging');
    if (viewer.setPointerCapture) {
      viewer.setPointerCapture(event.pointerId);
    }
  });

  viewer.addEventListener('pointermove', handlePointerMove);
  viewer.addEventListener('pointerup', handlePointerUp);
  viewer.addEventListener('pointercancel', handlePointerUp);
  viewer.addEventListener('pointerleave', handlePointerUp);

  startPreload();
  $pane.data('viewerInited', true);
}

function getCurrentImageSlideIndex($container) {
  var $counter = getImageCounter($container);
  var counterIndex = parseInt(($counter.text() || '').trim(), 10);
  if (!isNaN(counterIndex) && counterIndex > 0) {
    return counterIndex - 1;
  }

  var $activeDot = getMediaDots($container).filter('.is-primary').first();
  if ($activeDot.length) {
    var activeDotIndex = parseInt($activeDot.attr('data-dot-index'), 10);
    if (!isNaN(activeDotIndex)) {
      return activeDotIndex;
    }
  }

  return 0;
}

function getImageCounter($container) {
  return $container.find('.media-counter-current').first();
}

function getMediaDots($container) {
  return $container.find('.product-media-carousel_thumbs_wrap [data-carousel-dot], .product-media-carousel-mobile__dots-carousel-container [data-carousel-dot]');
}

function clearImageRestoreTimer($container) {
  var pendingRestoreTimer = $container.data('imageRestoreTimer');
  if (!pendingRestoreTimer) return;
  clearTimeout(pendingRestoreTimer);
  $container.removeData('imageRestoreTimer');
}

function resolveTargetPane($carousel, mode) {
  var resolvedMode = mode;
  var $targetPane = $carousel.find('[data-media-pane="' + resolvedMode + '"]');
  if ($targetPane.length) {
    return { mode: resolvedMode, pane: $targetPane };
  }
  resolvedMode = 'image';
  return {
    mode: resolvedMode,
    pane: $carousel.find('[data-media-pane="image"]')
  };
}

function setPaneVisibility($carousel, $targetPane) {
  $carousel.find('[data-media-pane]').addClass('hide');
  $targetPane.removeClass('hide');
}

function setImageControlVisibility($carousel, mode) {
  var $controls = $carousel.find('[data-image-only-control]');
  if (mode === 'image') {
    $controls.removeClass('hide');
    return;
  }
  $controls.addClass('hide');
}

function restoreImageSlideIndex($container, slideIndex) {
  if (typeof slideIndex !== 'number' || slideIndex < 0) return;
  var currentIndex = getCurrentImageSlideIndex($container);
  if (currentIndex === slideIndex) return;
  var $allDots = getMediaDots($container);
  var targetIndexText = String(slideIndex);
  var $targetDot = $allDots.filter(function() {
    return ($(this).attr('data-dot-index') || '') === targetIndexText;
  }).first();
  if (!$targetDot.length && slideIndex === 0) {
    $targetDot = $allDots.first();
  }
  if ($targetDot.length) {
    $targetDot.trigger('click');
  }
}

function moveImageToFirstSlide($container) {
  var $allDots = getMediaDots($container);
  var $firstDot = $allDots.filter(function() {
    return ($(this).attr('data-dot-index') || '') === '0';
  }).first();
  if (!$firstDot.length) {
    $firstDot = $allDots.first();
  }
  if ($firstDot.length) {
    $firstDot.trigger('click');
  }
  getImageCounter($container).text('1');
}

function restoreImageStateOnReturn($container, prevMode) {
  clearImageRestoreTimer($container);
  var restoreTimer = setTimeout(function() {
    if (($container.data('productMediaMode') || '').toString() !== 'image') return;
    if (prevMode === '360' || prevMode === 'video') {
      moveImageToFirstSlide($container);
    } else {
      var savedImageSlideIndex = $container.data('imageSlideIndex');
      if (typeof savedImageSlideIndex !== 'number') return;
      restoreImageSlideIndex($container, savedImageSlideIndex);
    }
    $container.removeData('imageRestoreTimer');
  }, 0);
  $container.data('imageRestoreTimer', restoreTimer);
}

function setProductMediaMode($container, mode) {
  var $carousel = $container.find('product-media-carousel').first();
  if (!$carousel.length) return;
  var prevMode = ($container.data('productMediaMode') || 'image').toString();

  var target = resolveTargetPane($carousel, mode);
  mode = target.mode;
  var $targetPane = target.pane;
  setPaneVisibility($carousel, $targetPane);

  if (prevMode === 'image' && mode !== 'image') {
    $container.data('imageSlideIndex', getCurrentImageSlideIndex($container));
  }

  setImageControlVisibility($carousel, mode);
  if (mode === 'image') {
    if (prevMode !== 'image') {
      restoreImageStateOnReturn($container, prevMode);
    }
  } else {
    clearImageRestoreTimer($container);
  }

  if (mode === '360') {
    initProduct360Viewer($targetPane);
  }

  $carousel.find('.product-media-video video').each(function() {
    if (mode !== 'video' && this.pause) {
      this.pause();
    }
  });

  $container.data('productMediaMode', mode);
}

function warmupProduct360Viewers() {
  $('div[data-product-media-container] [data-media-pane="360"]').each(function() {
    initProduct360Viewer($(this));
  });
}

function scheduleProduct360Warmup() {
  if (window.__pdpMedia360WarmupScheduled) return;
  window.__pdpMedia360WarmupScheduled = true;

  if (window.requestIdleCallback) {
    window.requestIdleCallback(function() {
      warmupProduct360Viewers();
    }, { timeout: 2500 });
    return;
  }

  setTimeout(function() {
    warmupProduct360Viewers();
  }, 1800);
}

function bindProductMediaHandlers() {
  var eventNamespace = '.pdpMedia360';

  $(document)
    .off('click' + eventNamespace, '.product-media-carousel_thumbs_wrap .carousel__slide')
    .on('click' + eventNamespace, '.product-media-carousel_thumbs_wrap .carousel__slide', function() {
      var $container = $(this).closest('div[data-product-media-container]');
      if (!$container.length) return;
      setProductMediaMode($container, 'image');
      $container.find('.pdp-toggle-image_video .toggle-image_video[data-name="image"]').addClass('active').siblings().removeClass('active');
    });

  $(document)
    .off('click' + eventNamespace, '.pdp-toggle-image_video .toggle-image_video')
    .on('click' + eventNamespace, '.pdp-toggle-image_video .toggle-image_video', function() {
      var $btn = $(this);
      var mode = ($btn.data('name') || '').toString();
      var $container = $btn.closest('div[data-product-media-container]');

      $btn.addClass('active').siblings().removeClass('active');
      setProductMediaMode($container, mode);
    });
}

scheduleProduct360Warmup();
bindProductMediaHandlers();
// $(document).on('click', '.panel-subcontent-wrap .learn-more', function(e) {
//   e.preventDefault();
//   var $wrap = $(this).closest('.panel-subcontent-wrap');
//   var $panel = $(this).closest('.panel');
  
//   if ($wrap.hasClass('expanded')) {
//     // 收起
//     $wrap.removeClass('expanded');
//     $(this).text('Learn More');
//   } else {
//     // 展开到实际高度
//     $wrap.addClass('expanded');
//     $(this).text('Show Less');
//   }
// });


// document.addEventListener('change', function(event) {
//   if (event.target.matches('.product-form.multiple-variants .cart-drawer-related__variant')) {
//     var selectElement = event.target;
//     var selectedValue = selectElement.value;
//     // console.log('select:', selectedValue);
    
//     var form = selectElement.closest('form');
//     var idInput = form.querySelector('input[name="id"]');
//     idInput.value = selectedValue;
//     document.querySelector(".cart-drawer").classList.remove('is-cart-loading');
//   }
// });

/*** product card 2 hover ***/
  // $(document).on({
  //   mouseenter: function() {
  //     const img = $(this).find('.product-card__img');
  //     const productImg = img.attr('data-src'); 
  //     const secondImage = img.attr('data-hover');       
  //     if (secondImage) { 
  //       img.attr('src', secondImage); 
  //     }
  //   },
  //   mouseleave: function() {
  //     const img = $(this).find('.product-card__img'); 
  //     const productImg = img.attr('data-src'); 
  //     const secondImage = img.attr('data-hover'); 
  //     if (secondImage) {  img.attr('src', productImg); }
  //   }
  // },'.multiple-grid-item__desktop-content .product-card .product-card__images-wrapper')

/*** call us ***/
function updateCartNote(){
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: "clickedcallus" })
  })
  .then(response => response.json())
  .then(data => {
    // console.log('Order note updated:', data);
  })
  .catch(error => {
    console.error('Failed to update order note:', error);
  });
}
const callUsIcon = document.querySelector('.call-us-icon');
const callIcon = document.querySelector('.call-icon');
const closeIcon = document.querySelector('.call_us_close');
const closeIconSvg = document.querySelector('.call_us_close_icon')
const callUsDetails = document.querySelector('.call-us-details');

if (callUsIcon) {
  callUsIcon.addEventListener('click', () => {
    const isHidden = callUsDetails.classList.toggle('custom_hidden');
    
    callIcon.classList.toggle('custom_hidden', !isHidden);
    closeIcon.classList.toggle('custom_hidden', isHidden);
    closeIconSvg.classList.toggle('active', !isHidden);
    callUsIcon.classList.toggle('active');
    localStorage.setItem('called_us', 'true');
    updateCartNote()
  });
}

function openPhone(){
  window.location.href = "tel:+18885593099";
  localStorage.setItem('called_us', 'true');
  updateCartNote()
}
const calledUs = window.localStorage.getItem('called_us') === 'true';
if(calledUs){
  updateCartNote()
}

// document.querySelectorAll('.smooth-scroll').forEach(link => {
//   link.addEventListener('click', function(e) {
//     e.preventDefault();
//     const targetId = this.getAttribute('href')?.substring(1);
//     if (!targetId) return;

//     const target = document.getElementById(targetId);
//     if (!target) return;

//     const offset = Number(this.dataset.position) || 0;
//     const y = target.getBoundingClientRect().top + window.scrollY - offset;

//     window.scrollTo({
//       top: y,
//       behavior: 'smooth'
//     });
//   });
// });
// N2 geometry
// var toggleSwitch = document.getElementById('toggleSwitch');
// if (toggleSwitch) {
//   toggleSwitch.addEventListener('change', function () {
//     var stepThruContent = document.getElementById('stepThruContent');
//     var highStepContent = document.getElementById('highStepContent');
//     if (this.checked) {
//       stepThruContent.style.display = 'none';
//       highStepContent.style.display = 'block';
//     } else {
//       stepThruContent.style.display = 'block';
//       highStepContent.style.display = 'none';
//     }
//   });
// }

document.addEventListener('submit', function(event) {
  if (typeof window.dataLayer === 'undefined') {
    return;
  }
  const form = event.target;
  // login
  if (form.id === 'customer_login') {
    window.dataLayer.push({
      "event": "login",
      "method": "email"
    });
  }
  // register
  if (form.id === 'create_customer') {
    window.dataLayer.push({
      "event": "sign_up",
      "method": "email"
    });
  }
}, true);

document.addEventListener('change', function (e) {
  const variantInput = e.target.closest(
    '.product input[data-product-form-variant]'
  );
  if (!variantInput) return;

  const variantId = Number(variantInput.value);
  const variant = window.productVariants?.find(v => v.id === variantId);
  if (!variant) return;

  const stickyRoot = document.querySelector('.sticky-atc__inner');
  if (!stickyRoot) return;

  /* 图片 */
  if (variant.featured_image?.src) {
    const img = stickyRoot.querySelector('.sticky-atc__image img');
    img && (img.src = `${variant.featured_image.src}&width=64`);
  }

  /* 基础价（分） */
  const priceEl = stickyRoot.querySelector('[data-sticky-price]');
  if (priceEl) {
    priceEl.dataset.price = variant.price;
  }

  // 捆绑bundle
  if (variant.name.includes("Velotric T1 ST Plus Ebike")) {
    const bundleCard = document.querySelector(
      '.bundle-container product-card[data-id="7306271326391"]'
    );
    if (bundleCard) {
      const select = bundleCard.querySelector('select');
      if (select) {
        const targetValue = variant.option1 === "Large"
          ? "41772836257975"
          : "41772836225207";

        if (select.querySelector(`option[value="${targetValue}"]`)) {
          select.value = targetValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }
  // gomad
  if (variant.name.includes("Velotric GoMad Ebike")) {
    const titleEl = stickyRoot.querySelector('.sticky-atc__title-name');
    titleEl.textContent = variant.options[0];
  }

  updateStickyAtcPrice();
});

document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.dataLayer === 'undefined') {
    return;
  }
  // newsletter
  const subscribeForms = document.querySelectorAll('.newsletter__form');
  if (subscribeForms.length) {
    subscribeForms.forEach(function(form) {
      const subscribeButton = form.querySelector('button[name="commit"]');
      if (subscribeButton) {
        subscribeButton.addEventListener('click', function() {
          window.dataLayer.push({
            "event": "newsletter_subscription"
          });
        });
      }
    });
  }
});


(function () {

  const App = {

    /* =========================
     * Init
     * ========================= */
    init(scope = document) {
      this.initSwipers(scope);
      this.initYoutubeReview(scope);
    },
    /* Popup */
    popup: {
      getContent(content, name) {
        return (
          POPUP_CONTENT_BY_PAIR[`${content}|${name}`] ||
          POPUP_CONTENT_BY_NAME[name] ||
          POPUP_CONTENT_BY_CONTENT[content] ||
          ""
        );
      },

      open({ content, name }) {
        const root = document.querySelector("#custom_popup");
        if (!root) return;

        const popup = root.querySelector(".popup");
        const contentEl = root.querySelector(".popup__content");

        if (popup) {
          popup.classList.remove("n2x", "n2x_large");
          if (POPUP_CLASS_BY_NAME[name]) {
            popup.classList.add(POPUP_CLASS_BY_NAME[name]);
          }
        }

        if (contentEl) {
          contentEl.innerHTML = this.getContent(content, name);
        }

        if (content === "compare") {
          this.handleCompare(name);
          document.querySelector("#compare_popup")?.classList.add("active");
          return;
        }

        root.classList.add("active");
      },

      close() {
        document.querySelector("#custom_popup")?.classList.remove("active");
        document.querySelector("#compare_popup")?.classList.remove("active");
        document.querySelectorAll(".custom-popup-group").forEach((el) => {
          el.classList.remove("active");
        });
      },

      handleCompare(name) {
        let list = [];
        const compareListRaw = localStorage.getItem("compare_list");

        if (compareListRaw && compareListRaw !== "undefined") {
          try {
            list = JSON.parse(compareListRaw) || [];
          } catch (error) {
            list = [];
          }
        }

        if (!list.includes(name)) {
          list.push(name);
          localStorage.setItem("compare_list", JSON.stringify(list));
        }
      }
    },
    initAccordion() {
      // 不需要做任何初始化，占位用
    },
    /* =========================
     * Swiper 初始化（核心）
     * ========================= */
    
    initSwipers(scope = document) {

      /* ---------- Banner ---------- */
      scope.querySelectorAll('.banner-slider-container').forEach(el => {
        if (el.dataset.init) return;

        const track = el.querySelector('.banner-slider__track');
        if (!track) return;

        el.dataset.init = 'true';

        new Swiper(track, {
          loop: true,
          speed: 400,
          autoplay: {
            delay: parseInt(el.dataset.speed) || 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.custom-swiper-button-next'),
            prevEl: el.querySelector('.custom-swiper-button-prev'),
          }
        });
      });

      /* ---------- Testimonial ---------- */
      scope.querySelectorAll('.professional-testimonial-container').forEach(el => {
        if (el.dataset.init) return;

        const main = el.querySelector('.testimonial-box-container');
        const thumbs = el.querySelector('.testimonial-thumbs');
        if (!main || !thumbs) return;

        el.dataset.init = 'true';

        const thumbsSwiper = new Swiper(thumbs, {
          spaceBetween: el.dataset.style === "style2" ? 16 : 50,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            320: { slidesPerView: el.dataset.style === "style2" ? 1 : 3 },
            480: { slidesPerView: el.dataset.style === "style2" ? 1 : 3 },
            768: { slidesPerView: 4 },
            1300: { slidesPerView: 5 }
          }
        });

        new Swiper(main, {
          effect: 'fade',
          fadeEffect: { crossFade: true },
          speed: 800,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          thumbs: { swiper: thumbsSwiper },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          }
        });
      });

      /* ---------- Testimonial-2 ---------- */
      scope.querySelectorAll('.professional-testimonial-2-container').forEach(el => {
        if (el.dataset.init) return;

        const main = el.querySelector('.testimonial-box-container');
        if (!main) return;

        el.dataset.init = 'true';

        new Swiper(main, {
          spaceBetween: 0,
          slidesPerView: 1,
          effect: 'fade',
          loop: true,
          fadeEffect: { crossFade: true },
          // speed: 800,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.custom-arrow-next'),
            prevEl: el.querySelector('.custom-arrow-prev')
          }
        });
      });

      /* ---------- KOL ---------- */
      scope.querySelectorAll('.kol-testimonials-container').forEach(el => {
        if (el.dataset.init) return;

        const slider = el.querySelector('.kol-slider-container');
        if (!slider) return;

        el.dataset.init = 'true';

        new Swiper(slider, {
          spaceBetween: 30,
          slidesPerView: 2.5,
          loop: true,
          breakpoints: {
            320: { slidesPerView: 1 },
            480: { slidesPerView: 1 },
            1100: { slidesPerView: 1.5 },
            1800: { slidesPerView: 2.5 }
          },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.carousel-btn.next'),
            prevEl: el.querySelector('.carousel-btn.prev')
          },
          on: {
            slideChange(swiper) {
              App.handleVideoPlayback(el, swiper.activeIndex);
            }
          }
        });
      });

      /* ---------- ImgWithText ---------- */
      scope.querySelectorAll('.imgWithText-slideshow-container').forEach(el => {
        if (el.dataset.init) return;

        const slider = el.querySelector('.imgWTS-container');
        if (!slider) return;

        el.dataset.init = 'true';

        new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 5,
          loop: true,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.carousel-btn.next'),
            prevEl: el.querySelector('.carousel-btn.prev')
          },
          mousewheel: {
            forceToAxis: true,
          },
          slideToClickedSlide: true,
          threshold: 12
        });
      });

      /* ---------- Features ---------- */
      scope.querySelectorAll('.features-review-section-wrapper').forEach(el => {
        if (el.dataset.init) return;

        const slider = el.querySelector('.swiper');
        if (!slider) return;

        el.dataset.init = 'true';

        new Swiper(slider, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            870: { slidesPerView: 2,spaceBetween: 10 },
            1024: { slidesPerView: el.dataset.perRow ,spaceBetween: 20}
          }
        });
      });
      /* ---------- Products Key Feature example s1 pdp ---------- */
      scope.querySelectorAll('.key_feature_position').forEach(el => {
        const slider = el.querySelector('.productList__wrapper.swiper');
        if (!slider || slider.dataset.init) return;

        slider.dataset.init = 'true';

        new Swiper(slider, {
          preloadImages: false,
          lazy: true,
          slidesPerView: 3.5,
          scrollbar: {
            el: el.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
          spaceBetween: 30,
          breakpoints: {
            320: {
              slidesPerView: 1.5
            },
            480: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 2.5
            },
            1300: {
              slidesPerView: 3.5
            },
            1900: {
              slidesPerView: 4
            }
          },
          mousewheel: {
            forceToAxis: true,
          },
          threshold: 12
        });
      });
    },
    /* =========================
     * YouTube Review（懒加载版）
     * ========================= */
    initYoutubeReview(scope = document) {

      scope.querySelectorAll('.youtube-review-section').forEach(section => {
        if (section.dataset.init) return;
        section.dataset.init = 'true';

        const tabBtns = section.querySelectorAll('.review-tab-btn');
        const tabContents = section.querySelectorAll('.review-tab-content');

        const swipers = {}; // 存实例

        /* ===== 懒初始化函数 ===== */
        const initSwiperIfNeeded = (tabKey) => {
          if (swipers[tabKey]) {
            swipers[tabKey].update();
            return;
          }

          const content = section.querySelector(`.review-tab-content[data-tab="${tabKey}"]`);
          if (!content) return;

          const container = content.querySelector(`.review-swiper-${tabKey}`);
          if (!container) return;

          const nextBtn = content.querySelector('.carousel-button-next');
          const prevBtn = content.querySelector('.carousel-button-prev');
          const paginationEl = content.querySelector('.swiper-pagination');

          const columns = parseInt(container.dataset.column) || 1;

          swipers[tabKey] = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn
            },
            pagination: {
              el: paginationEl,
              clickable: true,
            },
            breakpoints: {
              870: {
                slidesPerView: columns > 2 ? 2 : 1,
              },
              1024: {
                slidesPerView: columns,
              }
            }
          });
        };

        /* ===== 初始：只初始化 active ===== */
        const activeContent = section.querySelector('.review-tab-content.active');
        if (activeContent) {
          initSwiperIfNeeded(activeContent.dataset.tab);
        }

        /* ===== Tab 切换 ===== */
        tabBtns.forEach(btn => {
          btn.addEventListener('click', () => {

            const target = btn.dataset.tab;

            tabBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            tabContents.forEach(content => {
              content.classList.remove('active');

              if (content.dataset.tab === target) {
                content.classList.add('active');

                // 懒初始化关键
                initSwiperIfNeeded(target);
              }
            });

          });
        });

        /* ===== Modal video ===== */
        const modal = section.querySelector('.video-modal');
        const closeBtn = section.querySelector('.close-modal');
        const iframe = section.querySelector('#youtubeVideo');

        if (modal && closeBtn && iframe) {
          const buildYoutubeSrc = (youtubeId, autoplay) => {
            const safeId = (youtubeId || '').trim();
            if (!safeId) return '';
            return `https://www.youtube.com/embed/${safeId}?autoplay=${autoplay ? 1 : 0}&rel=0`;
          };

          const openModal = (youtubeId) => {
            const nextSrc = buildYoutubeSrc(youtubeId, true);
            if (!nextSrc) return;

            iframe.src = nextSrc;
            modal.classList.add('active');
          };

          const closeModal = () => {
            modal.classList.remove('active');
            iframe.src = '';
          };

          section.querySelectorAll('.reviewBox[data-yid]').forEach(reviewBox => {
            reviewBox.addEventListener('click', () => {
              openModal(reviewBox.dataset.yid);
            });
          });

          closeBtn.addEventListener('click', closeModal);
          modal.addEventListener('click', (e) => {
            if (e.target === modal) {
              closeModal();
            }
          });

          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
              closeModal();
            }
          });
        }

      });

    },

    /* =========================
     * Video 控制
     * ========================= */
    handleVideoPlayback(container, activeIndex) {
      const slides = container.querySelectorAll('.swiper-slide');

      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;

        if (i === activeIndex) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    },

    
    

  };

  /* =========================================
   * 全局事件委托（统一管理）
   * ========================================= */

  document.addEventListener('click', function (e) {

    /* smooth scroll */
    const scrollLink = e.target.closest('.smooth-scroll');
    if (scrollLink) {
      e.preventDefault();

      // const id = scrollLink.getAttribute('href')?.substring(1);
      // const target = document.getElementById(id);
      // if (!target) return;
      const id = scrollLink.getAttribute('href')?.substring(1);
      if (!id) return;

      const isUserStoryPage = !!scrollLink.closest('#user-story-2');
      const isMobileViewport = window.matchMedia('(max-width: 768px)').matches;
      let target = null;

      if (isUserStoryPage && isMobileViewport) {
        const mobileTargets = Array.from(document.querySelectorAll(`[data-nav-anchor="${id}"]`));
        target = mobileTargets.find((item) => item.getClientRects().length > 0) || mobileTargets[0] || null;
      }

      if (!target) {
        target = document.getElementById(id);
      }

      if (!target) return;

      const offset = Number(scrollLink.dataset.position) || 0;

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth'
      });
    }

    /* =========================
    * Accordion（通用）
    * <div class="accordion">
        <div class="panel">
          <div class="panel-header">Title</div>
          <div class="panel-body">Content</div>
        </div>
      </div>
    * ========================= */

    /* learn more */
    const learnMoreBtn = e.target.closest('.accordion .learn-more');

    if (learnMoreBtn) {
      e.preventDefault();
      e.stopPropagation();

      const body = learnMoreBtn.closest('.panel-body');

      if (!body) return;

      if (body.classList.contains('expanded')) {
        body.classList.remove('expanded');
        learnMoreBtn.textContent = 'Show More';
      } else {
        body.classList.add('expanded');
        learnMoreBtn.textContent = 'Show Less';
      }

      return;
    }


    /* panel toggle */
    const header = e.target.closest('.accordion .panel-header');

    if (header) {

      const panel = header.closest('.panel');
      const container = header.closest('.accordion');
      const body = panel.querySelector('.panel-body');

      if (!panel || !body) return;

      const isOpen = panel.classList.contains('open');

      /* 是否单开（可配置） */
      const isSingle = container.dataset.accordion !== 'multi';

      if (isOpen) {
        $(body).stop(true).slideUp();
        panel.classList.remove('open');
      } else {

        if (isSingle) {
          container.querySelectorAll('.panel.open').forEach(p => {
            p.classList.remove('open');
            $(p).children('.panel-body').slideUp();
          });
        }

        panel.classList.add('open');
        $(body).stop(true).slideDown();
      }
    }

    /* =========================
    * PDP Media Switcher（可扩展）
    * ========================= */

    // const mediaToggle = e.target.closest('.pdp-toggle-image_video .toggle-image_video');

    // if (mediaToggle) {

    //   const mediaType = mediaToggle.dataset.media;

    //   /* 1️⃣ 按钮状态 */
    //   const btnGroup = mediaToggle.parentElement;

    //   btnGroup.querySelectorAll('.toggle-image_video')
    //     .forEach(btn => btn.classList.remove('active'));

    //   mediaToggle.classList.add('active');

    //   /* 2️⃣ 找容器 */
    //   const container = mediaToggle.closest('[data-product-media-container]');
    //   if (!container) return;

    //   /* 3️⃣ 切换所有 media */
    //   container.querySelectorAll('[data-name]').forEach(el => {

    //     if (el.dataset.media === mediaType) {
    //       el.classList.remove('hide');
    //     } else {
    //       el.classList.add('hide');

    //       /* 👉 如果是 video，顺手暂停 */
    //       const video = el.querySelector('video');
    //       if (video) {
    //         video.pause();
    //         video.currentTime = 0;
    //       }
    //     }

    //   });

    //   return;
    // }
    // const thumbSlide = e.target.closest('.product-media-carousel_thumbs_wrap .carousel__slide');

    // if (thumbSlide) {

    //   const container = thumbSlide.closest('[data-product-media-container]');
    //   if (!container) return;

    //   /* 找 image 按钮 */
    //   const imageBtn = container.querySelector('.toggle-image_video[data-name="image"]');

    //   if (imageBtn) {
    //     imageBtn.click(); // 👈 复用逻辑（关键！）
    //   }

    //   return;
    // }

    /* pdp popup open */
    const popupTrigger = e.target.closest('[data-popup]');
    if (popupTrigger) {
      e.preventDefault();

      App.popup.open({
        content: popupTrigger.dataset.popup,
        name: popupTrigger.dataset.popupName
      });

      return;
    }

    /* pdp popup close */
    const popupClose = e.target.closest('.popup__close-button, [data-close-btn], [data-close-small-btn]');
    if (popupClose) {
      App.popup.close();
      return;
    }

    /* click overlay close */
    const popupOverlay = e.target.closest('.custom-popup-group .popup, .popup.popup-promo, #custom_popup .popup');
    if (popupOverlay && !e.target.closest('.popup__content')) {
      App.popup.close();
    }
    

  });
  /* hover tab（header / mega menu 用） */
  document.addEventListener('mouseover', function (e) {

    const tabBtn = e.target.closest('[data-tab-trigger="hover"]');
    if (!tabBtn) return;

    const containerSelector = tabBtn.dataset.tabContainer;
    const targetId = tabBtn.dataset.tabTarget;

    const container = document.querySelector(containerSelector);
    if (!container) return;

    /* 防抖：避免重复触发 */
    if (tabBtn.classList.contains('active')) return;

    /* 按钮 active */
    container.querySelectorAll('.bike-nav-tab-item')
      .forEach(el => el.classList.remove('active'));

    tabBtn.classList.add('active');

    /* 内容切换 */
    container.querySelectorAll('.bike-nav-tab_wrap')
      .forEach(el => el.classList.remove('active'));

    const target = document.getElementById(targetId);
    if (target) target.classList.add('active');

  });
  document.addEventListener('change', function (e) {

    /* =========================
   * Cart Drawer Variant Sync
   * ========================= */
    const variantSelect = e.target.closest(
      '.product-form.multiple-variants .cart-drawer-related__variant'
    );

    if (variantSelect) {

      const form = variantSelect.closest('form');
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      /* 同步 variant */
      idInput.value = variantSelect.value;

      /* 状态恢复 */
      const cartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-cart-loading');
      }

      return;
    }

    /* toggleSwitch */
    if (e.target.id === 'toggleSwitch') {
      const step = document.getElementById('stepThruContent');
      const high = document.getElementById('highStepContent');

      if (!step || !high) return;

      step.style.display = e.target.checked ? 'none' : 'block';
      high.style.display = e.target.checked ? 'block' : 'none';
    }

  });

  /* =========================================
   * 生命周期控制（关键）
   * ========================================= */

  // 初始执行（静态 DOM）
  App.init();

  // Shopify section 动态加载
  document.addEventListener('shopify:section:load', function (e) {
    App.init(e.target);
  });

  // DOM 变化兜底（Rebuy / Ajax）
  const observer = new MutationObserver(() => {
    App.init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* 暴露给全局（兼容旧代码） */
  window.VelotricApp = App;

})();




